


















































import Vue, { PropType } from "vue";
import SharedManuscriptList from "@/components/organisms/SharedManuscriptList.vue";
import SharedManuscriptContent from "@/components/organisms/SharedManuscriptContent.vue";
import SharedManuscriptComment from "@/components/organisms/SharedManuscriptComment.vue";
import CheckboxIcon from "@/components/atoms/CheckboxIcon.vue";
import { SharedLink } from "@/lib/models";
import isMobile from "ismobilejs";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    SharedManuscriptList,
    SharedManuscriptContent,
    SharedManuscriptComment,
    CheckboxIcon,
  },
  props: {
    sharedLinkId: {
      type: String as PropType<string>,
    },
    novelId: {
      type: String as PropType<string>,
    },
    manuscriptKey: {
      type: String as PropType<string>,
    },
  },
  data() {
    return {
      isChecked: false,
      isAgreed: false,
    };
  },
  methods: {
    onClickCheckbox() {
      this.isChecked = !this.isChecked;
    },
    onClickStart() {
      this.isAgreed = true;
    },
  },
  computed: {
    sharedLink() {
      return this.$store.getters["sharedLinkModule/sharedLink"] as SharedLink;
    },
    isEnabledSharedLink() {
      const sharedLink = this.sharedLink as SharedLink;
      return sharedLink ? sharedLink.enabled : false;
    },
  },
  created() {
    const { sharedLinkId, novelId } = this;
    this.$store.dispatch("sharedLinkModule/initializeSharedLink", {
      sharedLinkId,
      novelId,
    });
    this.$store.dispatch("sharedLinkModule/initializeCommentList", sharedLinkId);
    this.$store.dispatch("userModule/initialize");
  },
  watch: {
    sharedLink() {
      if (!this.isEnabledSharedLink || isMobile().phone || (isMobile().tablet && window.innerWidth < 2048)) {
        this.$router.push({
          name: "sharedLinkAccessDenied",
          query: { reason: "disabled" },
        });
      }
    },
  },
});

interface Props {
  sharedLinkId: string;
  novelId: string;
  manuscriptKey: string;
}

interface Data {
  isChecked: boolean;
  isAgreed: boolean;
}

interface Methods {
  onClickCheckbox: () => void;
  onClickStart: () => void;
}

interface Computed {
  sharedLink: SharedLink;
  isEnabledSharedLink: boolean | undefined;
}
